import { isConversionRequired, isEmpty, getCurrentCountry, countryCode } from 'utils/appUtils'
import { util } from '.'
import { store } from '../config/redux'
import { getClientId, getClientSecret } from '../network/api/networkSettings'

export const request = {
    newUser: ({
        first_name,
        last_name,
        email,
        phone_number,
        password,
        accepts_us_terms,
        accepts_ca_terms,
        marketingEmailNoty,
        referralCode,
    }) => {
        const { location, user } = store.getState()
        let request = {}
        if (getCurrentCountry(location, user) === countryCode.CA) {
            request = {
                first_name,
                last_name,
                email,
                phone_number,
                password,
                country: 'CA',
                accepts_ca_terms,
                accepts_ca_communications: marketingEmailNoty,
            }
            if (referralCode) {
                request.referral_code = referralCode
            }
            return request
        }
        request = {
            first_name,
            last_name,
            email,
            phone_number,
            password,
            country: 'US',
            accepts_us_terms,
        }
        if (referralCode) {
            request.referral_code = referralCode
        }
        return request
    },
    signInRequest: (username, password) => {
        const request = {
            userName: util.encrypt(username),
            password: util.encrypt(password),
        }
        const { isConversion, customer_id } = isConversionRequired()
        if (isConversion) {
            request.guest_id = customer_id
        }

        return request
    },

    signInWithFbRequest: (token, email) => {
        const request = {
            provider: 'facebook',
            email,
            access_token: token,
            client_id: getClientId(),
            client_secret: getClientSecret(),
            type: 'jwt',
        }

        const { isConversion, customer_id } = util.isConversionRequired()
        if (isConversion) {
            request.guest_id = customer_id
        }

        return request
    },
    createGetSubCategoryRequest: (storeId, category_id, selectedSortTypes) => {
        const request = {}
        request.facet_level = ['category_id', 'subcategory']
        request.attributes = {
            store_id: storeId,
            category_id,
        }
        const sort = {}
        if (selectedSortTypes.length > 0) {
            const selectedSortTypesLowercase = selectedSortTypes[0].toLowerCase()
            sort[selectedSortTypesLowercase] = 1
        } else {
            sort.popularity = 1
        }
        request.sort = [sort]
        return request
    },
    createGetGlobalSubCategoryRequest: (category_id, selectedSortTypes) => {
        const request = {}
        request.facet_level = ['category_id', 'subcategory']
        request.attributes = {
            category_id,
        }

        const sort = [{ popularity: 1 }, { name: 1 }, { original_price: 1 }]

        request.sort = sort
        return request
    },
    createApplyCategoryFiltersRequest: (storeId, categoryId, selectedSortTypes, selections, selectedPickupDate, selectedPickupTime) => {
        try {
            // const categoriesDetails = products['categoriesDetails']
            // const currentCategoryIndex = categoriesDetails.findIndex(
            //     categoryDetails => categoryDetails.category_id === categoryId
            // )
            // const categoryFilters = categoriesDetails[currentCategoryIndex].filters // need clearity

            const request = {}
            const sort = {}
            if (selectedSortTypes.length > 0) {
                const selectedSortTypesLowercase = selectedSortTypes[0].toLowerCase()
                sort[selectedSortTypesLowercase] = 1
            } else {
                sort.popularity = 1
            }
            request.facet_level = ['category_id', 'subcategory']
            request.attributes = {
                store_id: storeId || null,
                category_id: categoryId,
                ...selections,
            }
            if(selectedPickupDate && selectedPickupTime){
                request.selectedPickupDate = selectedPickupDate
                request.selectedPickupTime = selectedPickupTime
            }
            request.sort = [sort]
            return request
        } catch (error) {
            console.log('here is error', error)
        }
    },
    createApplyGlobalCategoryFiltersRequest: (categoryId, selectedSortTypes, selections) => {
        try {
            const request = {}
            const sort = {}
            if (selectedSortTypes.length > 0) {
                const selectedSortTypesLowercase = selectedSortTypes[0].toLowerCase()
                sort[selectedSortTypesLowercase] = 1
            } else {
                sort.popularity = 1
            }
            request.facet_level = ['category_id', 'subcategory']
            request.attributes = {
                category_id: categoryId,
                ...selections,
            }
            request.sort = [sort]
            return request
            // eslint-disable-next-line no-empty
        } catch (error) {}
    },
    createApplySubCategoriesFiltersRequest: (
        storeId,
        categoryId,
        subCategoryName,
        selectedSortTypes,
        selections,
        selectedPickupDate,
        selectedPickupTime
    ) => {
        const request = {}
        const sort = {}

        if (selectedSortTypes.length > 0) {
            const selectedSortTypesLowercase = selectedSortTypes[0].toLowerCase()
            sort[selectedSortTypesLowercase] = 1
        } else {
            sort.popularity = 1
        }

        if(selectedPickupDate && selectedPickupTime){
            request.selectedPickupDate = selectedPickupDate
            request.selectedPickupTime = selectedPickupTime
        }

        request.facet_level = subCategoryName ? ['category_id', 'subcategory'] : ['category_id']
        request.attributes =
            subCategoryName !== ''
                ? {
                      store_id: storeId,
                      category_id: categoryId,
                      subcategory: [subCategoryName],
                      ...selections,
                  }
                : {
                      store_id: storeId,
                      category_id: categoryId,
                      ...selections,
                  }
        request.sort = [sort]
        return request
    },
    createApplyGlobalSubCategoriesFiltersRequest: (
        categoryId,
        subCategoryName,
        selectedSortTypes,
        selections
    ) => {
        const request = {}
        const sort = {}
        if (selectedSortTypes.length > 0) {
            const selectedSortTypesLowercase = selectedSortTypes[0].toLowerCase()
            sort[selectedSortTypesLowercase] = 1
        } else {
            sort.popularity = 1
        }

        request.facet_level = subCategoryName ? ['category_id', 'subcategory'] : ['category_id']
        request.attributes =
            subCategoryName !== ''
                ? {
                      category_id: categoryId,
                      subcategory: [subCategoryName],
                      ...selections,
                  }
                : {
                      category_id: categoryId,
                      ...selections,
                  }
        request.sort = [sort]
        return request
    },
    storesByLocationReq: address => {
        const { user } = store.getState()
        const userAcct = user.toJS()
        const { userProfile } = userAcct
        return {
            delivery_flag: 'D',
            lattitude: address.lattitude,
            longitude: address.longitude,
            training_mode: (userProfile && userProfile.training_mode) || false,
            nickname: address.nickname || '',
            city: address.city,
            street: address.street,
            state: address.state,
            zipcode: address.zip,
            apt: address.apt,
            country: address.country,
            address: address.formatted_address,
        }
    },
    searchSuggestRequest: (searchTerm, suggest, tab) => {
        const { location, catering } = store.getState()
        const { selectedAddress } = location.toJS()
        // Use catering address when tab is catering, otherwise use shop address
        const currentAddress = tab === 'catering' ? catering?.address : selectedAddress
        const searchRequest = {
            query: searchTerm,
            suggest,
        }
        
        // Add tab parameter based on current page
        if (tab) {
            searchRequest.tab = tab
        }
        
        // For catering tab, include pickup date/time if address is set
        if (tab === 'catering' && catering?.address) {
            if (catering?.schedule?.date) {
                searchRequest.scheduledPickupDate = catering.schedule.date
            }
            if (catering?.schedule?.time) {
                searchRequest.scheduledPickupTime = catering.schedule.time
            }
        }
        
        const exclude_tags = getExcludedTags()
        if (!isEmpty(currentAddress) && exclude_tags.length) {
            searchRequest.exclude_tags = exclude_tags
        }
        return searchRequest
    },
    searchRequest: (product, tab) => {
        const { location, catering } = store.getState()
        const { selectedAddress } = location.toJS()
        // Use catering address when tab is catering, otherwise use shop address
        const currentAddress = tab === 'catering' ? catering?.address : selectedAddress
        const searchRequest = {
            suggest: false,
        }
        
        // Add tab parameter based on current page
        if (tab) {
            searchRequest.tab = tab
        }
        
        // For catering tab, include pickup date/time if address is set
        if (tab === 'catering' && catering?.address) {
            if (catering?.schedule?.date) {
                searchRequest.scheduledPickupDate = catering.schedule.date
            }
            if (catering?.schedule?.time) {
                searchRequest.scheduledPickupTime = catering.schedule.time
            }
        }
        
        const exclude_tags = getExcludedTags()
        if (!isEmpty(currentAddress) && exclude_tags.length) {
            searchRequest.exclude_tags = exclude_tags
        }
        if (product) {
            if (typeof product === 'object') {
                searchRequest.query = product.name
                searchRequest.attributes = { id: product.product_id }
            } else {
                searchRequest.attributes = { id: product }
            }
        }
        return searchRequest
    },
}

export const getExcludedTags = () => {
    const excludedTags = ['tobacco', 'cbd']
    return excludedTags
}
